// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sample[data-v-61cbd292] {\n  margin-top:20px;\n  padding:5px;\n  border: 1px dotted #d8d8d8;\n}\n.sample p[data-v-61cbd292] {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
